export const initSwiper = (element, config = {}) => {
  if (!element) return;

  const swiperConfig = {
    ...config,
  };

  const swiper = new Swiper(element, swiperConfig);

  return swiper;
};
